var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMiningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6221 1.65776C23.9275 3.91886 21.549 7.7361 17.3094 10.1838C13.0698 12.6315 8.57471 12.7828 7.26926 10.5217C5.96381 8.26061 8.34239 4.44336 12.5819 1.99565C16.8215 -0.452062 21.3166 -0.603342 22.6221 1.65776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89986 14.6097C7.51075 14.6097 9.6273 18.5783 9.6273 23.4737C9.6273 28.3691 7.51075 32.3376 4.89986 32.3376C2.28896 32.3376 0.172417 28.3691 0.172417 23.4737C0.172416 18.5783 2.28896 14.6097 4.89986 14.6097Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27779 36.4465C8.58323 34.1854 13.0784 34.3367 17.3179 36.7844C21.5575 39.2321 23.936 43.0493 22.6306 45.3104C21.3252 47.5715 16.83 47.4203 12.5905 44.9725C8.35091 42.5248 5.97234 38.7076 7.27779 36.4465Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3779 45.3055C26.0725 43.0444 28.4511 39.2272 32.6906 36.7794C36.9302 34.3317 41.4253 34.1805 42.7307 36.4416C44.0362 38.7027 41.6576 42.5199 37.4181 44.9676C33.1785 47.4153 28.6834 47.5666 27.3779 45.3055Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1002 32.3278C42.4893 32.3278 40.3727 28.3593 40.3727 23.4638C40.3727 18.5684 42.4893 14.5999 45.1002 14.5999C47.711 14.5999 49.8276 18.5684 49.8276 23.4638C49.8276 28.3593 47.711 32.3278 45.1002 32.3278Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7222 10.4763C41.4168 12.7374 36.9217 12.5861 32.6821 10.1384C28.4425 7.69065 26.064 3.8734 27.3694 1.6123C28.6749 -0.648798 33.17 -0.497519 37.4095 1.95019C41.6491 4.3979 44.0277 8.21515 42.7222 10.4763Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMiningIcon);
export default __webpack_public_path__ + "static/media/socialMiningIcon.5d169f2e74a60c56ff688185972b9c9e.svg";
export { ForwardRef as ReactComponent };